import * as React from 'react';
import { Card, Tabs } from 'antd';
import { RecordsBox } from './Records.css';
import { RocketOutlined } from '@ant-design/icons';
import gamesList from '../../components/ChooseGame/gamesList';
import VisualRecords from '../Profile/Records/VisualRecords/VisualRecords';
import AimRecords from '../Profile/Records/AimRecords/AimRecords';
import ReactionRecords from '../Profile/Records/ReactionRecords/ReactionRecords';

const { TabPane } = Tabs;

const Records = () => {

    const renderScores = (id: string, gameId: number) => {
        switch(id) {
            case 'vm':
                return <VisualRecords gameId={gameId} />
            case 'at':
                return <AimRecords gameId={gameId} />
            case 'rt':
                return <ReactionRecords gameId={gameId} />
            default:
                return <VisualRecords gameId={gameId} />
        }
    };

    const renderProfileHeader = () => {
        return <div>
            <RocketOutlined size={30} /> Records
        </div>
    };

    return (
        <RecordsBox>
            <Card title={renderProfileHeader()} style={{ margin: "16px 16px", display: 'flex', flexDirection: 'column', flex: 1 }}>
                <Tabs style={{display: 'flex', height: '100%'}} tabPosition="left">
                    {gamesList.map((game, index) =>
                        <TabPane tab={game.name} key={index}>
                            {renderScores(game.id, game.gameId)}
                        </TabPane>
                    )}
                </Tabs>
            </Card>
        </RecordsBox>
    );
};

export default Records;